// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from '../../router/pc/index'
import '../../utils/ele'
import * as echarts from 'echarts';

import VueAwesomeSwiper  from 'vue-awesome-swiper'
import VideoPlayer from 'vue-video-player'
import Toast from '../../utils/toast'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import '@/style/element-variables.scss'

// import 'lib-flexible'
import '@/style/common.scss' // global css
import 'swiper/dist/css/swiper.css'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import storage from '@/utils/storage' 


import { getImgSrc, getHomeApiBaseUrl } from '../../utils/img'
import dayjs from 'dayjs'
import { formatDate, getInformationUrl, getInformation } from '../../utils/tool'
import { getDictNameByValue } from '@/config/dict'

Vue.use(ElementUI);
Vue.use(Toast)
Vue.use(VideoPlayer)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.prototype.$storage = storage
Vue.prototype.getImgSrc = getImgSrc
Vue.prototype.getInformationUrl = getInformationUrl
Vue.prototype.getInformation = getInformation
Vue.prototype.getHomeApiBaseUrl = getHomeApiBaseUrl
Vue.prototype.getDictNameByValue = getDictNameByValue
Vue.prototype.dayjs = dayjs
Vue.config.productionTip = false
Vue.prototype.formatDate = formatDate
Vue.prototype.$echarts = echarts;

/* eslint-disable no-new */
window.vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/framework/pc/index.js